<template>
  <div class="app">
    <Navigation />
    <main class="min-h-screen bg-gray-50">
      <router-view></router-view>
    </main>
  </div>
</template>

<script setup lang="ts">
import Navigation from './components/Navigation.vue';
</script>

<style>
.app {
  @apply min-h-screen bg-gray-50;
}
</style>